document.addEventListener("DOMContentLoaded", function () {
  const btn = document.getElementById("zizo-check-size");

  if (!btn) return;

  btn.addEventListener("click", function (e) {
    e.preventDefault();

    const chest = parseFloat(document.getElementById("zizo-chest").value);
    const back = parseFloat(document.getElementById("zizo-back").value);
    const neck = parseFloat(document.getElementById("zizo-neck").value);
    const weight = parseFloat(document.getElementById("zizo-weight").value || 0);

    const resultBox = document.getElementById("zizo-result");
    if (!resultBox) return;

    if (!chest || !back || !neck) {
      resultBox.innerHTML = `<p style="color:red;">Please enter all required measurements 🐶📏</p>`;
      return;
    }

    const sizes = [
      { size: "S", chest: 39, back: 22, neck: 28 },
      { size: "M", chest: 45, back: 26, neck: 30 },
      { size: "L", chest: 51, back: 30, neck: 34 },
      { size: "XL", chest: 58, back: 35, neck: 39 },
      { size: "XXL", chest: 66, back: 40, neck: 43 },
    ];

    const score = {};
    sizes.forEach((s) => {
      score[s.size] =
        Math.abs(s.chest - chest) +
        Math.abs(s.back - back) +
        Math.abs(s.neck - neck);
    });

    let best = Object.keys(score).reduce((a, b) =>
      score[a] < score[b] ? a : b
    );

    let emoji = "🐶🎉";
    if (best === "XL" || best === "XXL") emoji = "💪🐻";
    if (best === "S") emoji = "🐥✨";

    resultBox.innerHTML = `
      <div style="padding:12px; border-radius:8px; background:#fff6f8;">
        <h3>Your recommended size: <strong>${best}</strong> ${emoji}</h3>
        <p>This size is selected by ZIZO AI based on chest, back, and neck measurements.</p>
      </div>
    `;
  });
});

